import { render } from "./TheScriptDetails.vue?vue&type=template&id=108a0e43"
import script from "./TheScriptDetails.vue?vue&type=script&lang=js"
export * from "./TheScriptDetails.vue?vue&type=script&lang=js"

import exportComponent from "d:\\buildagent\\agent-cidev01-a\\205\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__